module.exports = __webpack_public_path__ + "img/cubes--dark.1caf0b4c.png";